import { render, staticRenderFns } from "./ModalOtpCode.vue?vue&type=template&id=4002008e"
import script from "./ModalOtpCode.vue?vue&type=script&lang=js"
export * from "./ModalOtpCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports